import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import PosEventsPage from 'modules/restaurant/posEvents/PosEventsPage';

export default function DashRestaurantPosEvents() {
    return (
        <DashEstablishmentContainer title='Eventos'>
            <PosEventsPage />
        </DashEstablishmentContainer>
    );
}
